import * as React from 'react';
import { Input as BaseInput, InputProps } from '@mui/base/Input';
import { RootDiv, TextareaElement } from '../../expanded-theme';

const MultilineInput = React.forwardRef(function CustomInput(
  props: InputProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  return (
    <BaseInput
        slots={{
            root: RootDiv,
            input: 'input',
            textarea: TextareaElement,
        }}
        {...props}
        ref={ref}
    />
  );
});

export default MultilineInput;